var _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEthyLogoFallback = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 132 36",
    width: 132,
    height: 36,
    role: "img",
    "aria-label": "ethy",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ethy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 27,
    fontFamily: "Poppins, 'Helvetica Neue', Helvetica, Arial, sans-serif",
    fontSize: 30,
    fontWeight: 600,
    letterSpacing: -0.5,
    fill: "#12160f"
  }, "ethy")));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEthyLogoFallback);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ethy-logo-fallback.067f5eebeb10fcce8ea87b957c1d3dbc.svg";